import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import { Accordion, Button, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import CurrencyInput from "../../components/form-fields/CurrencyInput";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';
import MultiSelect from "../../components/form-fields/MultiSelect";
import { formatListWithParameter } from "../../utils";                   /* Added Line */

export default function DocumentStates() {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [refreshConfig, setRefreshConfig] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [departmanId, setDepartmanId] = useState(null);
  const [t, i18n] = useTranslation();         /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);

  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepTurIds: values.talepTurIds,
      //departmentId: values.departmentId,
      durumKod: values.durumKod,
      dosyaDurum: values.dosyaDurum,
      dosyaDurumEn: values.dosyaDurumEn,
      dosyaDurumTr: values.dosyaDurumTr,
      id: values.id,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      talepTurIds: data.talepTurIds,
      //departmentId: data.departmentId,
      durumKod: data.durumKod,
      dosyaDurum: data.dosyaDurum,
      dosyaDurumTr: data.dosyaDurumTr,
      dosyaDurumEn: data.dosyaDurumEn,
      id: data.id,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  const onDepartmentChanged = (value) => {
    setDepartmanId(value);
    setRefreshConfig(!refreshConfig);
  };
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button className="btn-xs"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
    );
  };
  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                  } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="dosya-durum/config"
                    configParameterName="id"
                    configParameterValue={departmanId}
                    configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                    refreshConfig={refreshConfig}
                  >
                    {/*<Field
                      name="departmentId"
                      label={t("documentStates.departman")}
                      colNumber="3"
                      oper="EQ"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.department}
                      onChangeFunc={(opt) => onDepartmentChanged(opt)}
                    />*/}
                    <Field
                      name="id"
                      label={t("documentStates.talepTürleri")}
                      colNumber="3"
                      oper="EQ"
                      joinEntity="talepTur"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.talepTur}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("pageTitleofDemandCreate.dosyaDurum")}
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              configParameterName="id"
              configParameterValue={departmanId}
              configReqType={"POST"}
              endPointUrl="dosya-durum/create"
              fetchPointUrl="dosya-durum/find"
              editPointUrl="dosya-durum/update"
              configPointUrl="dosya-durum/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              {/*<Field
                name="departmentId"
                label={t("documentStates.departman")}
                colNumber="12"
                component={Select}
                options={configData && configData.department}
                onChangeFunc={(opt) => onDepartmentChanged(opt)}
              />*/}
              <Field
                name="talepTurIds"
                label={t("documentStates.talepTürleri")}
                colNumber="12"
                component={MultiSelect}
                options={configData && configData.talepTur}
              />
              <Field
                name="durumKod"
                label={t("documentStates.durumKodu")}
                colNumber="12"
                component={CurrencyInput}
              />
              <Field
                name="dosyaDurumTr"
                label={t("documentStates.dosyaDurumuTr")}
                colNumber="12"
                component={TextInput}
              />
              <Field
                name="dosyaDurumEn"
                label={t("documentStates.dosyaDurumuEn")}
                colNumber="12"
                component={TextInput}
                onlyEnglish={true}
              />
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="dosya-durumları"
            endpoint="dosya-durum/list"
            keyField="id"
            refreshList={refreshList}
            hideSelection={true}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header",
              },
              /*{
                dataField: "departmentName",
                text: `${t("demandList.departmanAdi")}`,
                sort: true,
              },*/
              {
                dataField: "talepTur",
                text: `${t("demandList.talepTuru")}`,
                formatter: (data) => formatListWithParameter(data, "talepTuru"),
                sort: true,
              },
              {
                dataField: "durumKod",
                text: `${t("demandList.durumKodu")}`,
                sort: true,
              },
              {
                dataField: "dosyaDurumTr",
                text: `${t("demandList.dosyaDurumuTr")}`,
                sort: true,
              },
              {
                dataField: "dosyaDurumEn",
                text: `${t("demandList.dosyaDurumuEn")}`,
                sort: true,
              },
              {
                dataField: "",
                text: "İşlemler",
                formatter: linkFollow,
                sort: false,
              },
            ]}
            customBody={{
              filters: filters,
            }}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                requestTo(ABT.ACTIVE, "dosya-durum/aktif-pasif"),
                requestTo(ABT.PASSIVE, "dosya-durum/aktif-pasif"),
                /* requestTo(ABT.DELETE, "dosya-durum/delete"), */
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
